import * as actionTypes from './actionTypes'

export function updateFieldWarning(warnings, merchandiseId) {
  warnings.merchandiseId = merchandiseId;
  return {
    type: actionTypes.UPDATE_FIELD_WARNINGS,
    warnings
  }
}

export function updateFieldValidationObject(field) {
  return {
    type: actionTypes.UPDATE_FIELD_VALIDATION_OBJECT,
    field
  }
}

/** Drop one field error immediately when the user fills/selects a value. */
export function clearValidationFieldError(tab, name) {
  return {
    type: actionTypes.CLEAR_VALIDATION_FIELD_ERROR,
    tab,
    name,
    key: `${tab}qwqr${name}`,
  }
}
